import React from 'react';

import Box from '@mui/material/Box';

import type { FlowComponentRenderProps, SpacerComponentConfig } from '../types';

const heightBySize: Record<NonNullable<SpacerComponentConfig['size']>, number> = {
  compact: 8,
  standard: 18,
  hero: 36,
};

const SpacerBlock: React.FC<FlowComponentRenderProps<SpacerComponentConfig>> = ({ config }) => (
  <Box aria-hidden sx={{ height: heightBySize[config.size ?? 'standard'], flexShrink: 0 }} />
);

export default SpacerBlock;
